// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3zH2h","title":"ClientReferral_title__259io","itemText":"ClientReferral_itemText__2rYZV"};